import { connect } from 'react-redux';
import { setCookie } from '@beef/utils';
import { selectHasCart } from "./store/slices/cart/selectors";
import { selectAuthFlag } from "./store/common";
import { ActionSearch } from "./store/slices/search/actions";
export var AUTH_COOKIE_NAME = 'isAuthorized';
export var authConnector = connect(function (state) {
  return {
    isAuth: selectAuthFlag(state)
  };
});
export var mountConnector = connect(null, function (dispatch, ownProps) {
  return {
    onMount: function onMount() {
      // Устанавливаем значение поисковой строки на основе параметка term
      dispatch(ActionSearch.setQuerySearchParams());
      setCookie({
        name: AUTH_COOKIE_NAME,
        value: Number(ownProps.isAuth).toString()
      });
    }
  };
});
export var cartConnector = connect(function (state) {
  return {
    hasCart: selectHasCart(state)
  };
});